import { render } from "./EProductField.vue?vue&type=template&id=23cc0492"
import script from "./EProductField.vue?vue&type=script&lang=js"
export * from "./EProductField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__